import useVuelidate from "@vuelidate/core";
import { Router, useRoute, onBeforeRouteUpdate } from "vue-router";

import {
    ApplyCompletedStages,
    ApplyPageStages,
    useApplicationStore,
} from "@/stores/application";
import { scrollErrorIntoView } from "@/composables/scrollErrorIntoView";
import { computed } from "vue";

export function useNavigation(router: Router) {
    const application = useApplicationStore();
    const v$ = useVuelidate();
    const route = useRoute();

    const isCompletedStage = (name: unknown) =>
        name === ApplyCompletedStages.SendDirectToPostPack ||
        name === ApplyCompletedStages.SendDirectToDownloadAndPrint;

    const isNotDownloadOrPostPackPages = computed(() =>
        route.name !== ApplyCompletedStages.SendDirectToPostPack &&
        route.name !== ApplyCompletedStages.SendDirectToDownloadAndPrint &&
        route.name !== ApplyPageStages[ApplyPageStages.PensionWise],
    );

    onBeforeRouteUpdate((to, from) => {
        const isReturningToApplyStep =
            to.path.startsWith("/apply/") &&
            !isCompletedStage(to.name);

        if (isCompletedStage(from.name) && isReturningToApplyStep) {
            // eslint-disable-next-line no-alert
            const confirmed = window.confirm("Are you sure you want to leave this page?");
            if (confirmed) {
                return { name: "results", query: { quotenumber: application.quoteNumber } };
            }
            return false;
        }
    });

    const changeApplyPage = (pageNo: ApplyPageStages) => {
        router.push({
            path: `/apply/${pageNo}`,
            query: { premiumId: application.premiumId, quoteNumber: application.quoteNumber },
        });
    };

    const goBack = () => {
        const isDownloadPage = route.name === ApplyCompletedStages.SendDirectToDownloadAndPrint;

        if (application.applicationStage === ApplyPageStages.Information || !isNotDownloadOrPostPackPages.value) {
            return router.push({ name: "results", query: { quotenumber: application.quoteNumber } });
        }

        changeApplyPage(isDownloadPage ? application.applicationStage : application.applicationStage - 1);
    };

    async function nextStep() {
        const isValid = await v$.value.$validate();
        if (isValid) {
            changeApplyPage(application.applicationStage + 1);
        } else {
            scrollErrorIntoView();
        }
    }

    return {
        nextStep,
        goBack,
        isNotDownloadOrPostPackPages,
    };
}
